import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  FormHelperText,
} from '@mui/material';
import UploadComponentMulti from '../../common/form/UploadComponentMulti';

const ParFileFormOne = ({ formik, name }) => {
  
  // UploadComponentMulti에서 공통 필드로 보낸 값을 가로채는 로직
  useEffect(() => {
    // 1. 공통 필드 'file'에 값이 들어왔고, 타겟이 나(name)인지 확인
    if (formik.values.file && formik.values.target === name) {
      
      // 2. 파일을 내 이름의 필드로 복사
      formik.setFieldValue(name, formik.values.file, true);
      
      // 3. 사용이 끝난 공통 필드들 초기화 (다음 박스를 위해)
      formik.setFieldValue('file', null, false);
      formik.setFieldValue('target', null, false);      
    }
  }, [formik.values.file, formik.values.target, name, formik]);

  return (
    <div>
      <Box
        // onClick={() => formik.setFieldValue('target', name, false)} -> UploadComponentMulti가 처리하므로 제거
        sx={{
          display: 'flex',
          flexDirection: 'row',
        }}
        noValidate
        autoComplete="off"
        // onSubmit={formik.handleSubmit} -> 이 컴포넌트가 전체 폼을 감싸는 것이 아니라면 제거
      >
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={12}>
            {/* UploadComponentMulti가 name을 받아 자체적으로 UI 렌더링 */}
            <UploadComponentMulti formik={formik} name={name} />
            
            {/* 에러 메시지 영역 */}
            {formik.touched[name] && Boolean(formik.errors[name]) && (
              <FormHelperText error sx={{ mx: 0, mt: 0.5 }}>
                {formik.errors[name]}
              </FormHelperText>
            )}
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default ParFileFormOne;
